'use client';
import React from 'react';

interface ControlPanelProps {
    children: React.ReactNode;
    onReset?: () => void;
}

export default function ControlPanel({ children, onReset }: ControlPanelProps) {
    return (
        <div className="flex flex-1 flex-col gap-[18px]">
            <div className="flex flex-col gap-[18px]">{children}</div>

            {onReset && (
                <div className="mt-auto pt-[18px]">
                    <button onClick={onReset} className="w-full text-[13px] text-muted">
                        Reset to defaults
                    </button>
                </div>
            )}
        </div>
    );
}
